import Request from './request';


async function fetchByShop(shop_id) {// 获取某门店下多地址
    return Request('get', "api/shop-users?id=" + shop_id);
}

async function save(id, data) {// 编辑或新建数据（有id为编辑，没有id为新建）
    if (id) {
        return Request('post', "api/shop-users/edit?id=" + id, data);
    } else {
        return Request('post', "api/shop-users/add", data);
    }
}

async function del(id) {// 删除数据
    return Request('delete', "api/shop-users/delete/" + id);
}

export default {
    fetchByShop,
    save,
    del,
};